import {
  P2TextDescription,
  P2TextLabel,
  P2Button,
  P2TextArea
} from "react-bootstrap-common-script";
import ClockPendingTask from "../../../assets/svg/clock-pending-task";
import InfoCircle from "../../../assets/svg/info-circle";
import InfoCard from "../../../components/info/info-card/info-card";
import { StageDMessageInfo, StageDReviewApplication } from "../../../models/classes/stage-d/Review-Application.class";
import { Helpers } from "../../../utils/helper";
import { useCallback } from "react";
import { Separator } from "../../../components/separator";
import he from "he";

interface MessageInterface{
  value: StageDReviewApplication,
  setFormValue: React.Dispatch<React.SetStateAction<StageDReviewApplication>>
}
function Message({...props}:MessageInterface) {


  const onValueChange = useCallback((uuid:string, value:any, type:string)=>{
    let temp = [...props.value.message_info];
    let index = temp.findIndex(e=>e.uuid === uuid);
    
    if(index !== -1){
      let newObj = new StageDMessageInfo(temp[index]);
      if(type === "is_saved"){
        newObj.is_saved = value;
      }
      if(type === "reply"){
        newObj.reply = value;
      }
      temp[index] = newObj;
    }


    props.setFormValue({...props.value, message_info:[...temp]})
  },[props]);

  const handleMessageChange = (uuid: string) => (value: string) => {
    onValueChange?.(uuid, value, "reply");
  }

  const handleSaveChange = (uuid: string, value: boolean) => () => {
    onValueChange?.(uuid, value, "is_saved");
  }

  return (
    <>
    {props.value.message_info.map((item, _index)=>{

      const reply = item?.reply ?? "";
      return (
        <div key={item.uuid} className="polymer-stage-d-container__section">
          <div className="polymer-stage-d-container__title">
            <P2TextDescription color="#000" title="Message" size="1.5rem" />
          </div>
          <div className="polymer-stage-d-container__subtitle">
            <P2TextLabel bold={700} marginBottom="16px" label={he.decode(item.subject ?? "")}
            />
            <div className="polymer-stage-d-container__subtitle__date">
              <ClockPendingTask />
              <p>Received on {Helpers.formatDate(item.received_date)}</p>
            </div>
          </div>
          <P2TextLabel marginBottom="33px" bold={400} label={he.decode(item.message ?? "")}/>
          <P2TextArea disabled={item.is_saved} maxLength={5000} placeholder="Type your reply here" labelFontWeight="700" label="Your reply" required={true} value={reply} onChange={handleMessageChange(item.uuid)}/>
          <p>Remaining characters: {Helpers.formatThousandSeparator(5000 - reply.length)}/5,000</p>
          <div className="polymer-staged-d-form-button__save" style={{ gap: 20 }}>
            <P2Button disabled={reply.length === 0} variant={"outline-primary"} onClick={handleSaveChange(item.uuid, !item.is_saved)}>
              {item.is_saved ? "Edit" : "Save"}
            </P2Button>
          </div>
          <div style={{ marginTop: 32, marginBottom: 24 }}>
            <InfoCard
              style={{
                backgroundColor: "#FFF",
                padding: "16px 12px 16px 8px",
              }}
              icon={<InfoCircle />}
              description={`Please reply by ${Helpers.formatDate(item.due_date)} or the application will be cancelled.`}
            />
          </div>
          {props.value.message_info.length > _index + 1 && <Separator variant="dashed" style={{margin:"32px 0 24px"}}/>}
        </div>
      )
    })}
    
    </>
  );
}

export default Message;
